const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/validators/action-validators.js